const profile = {
  title: "Il mio profilo",
  premiumBtn: "Vai premium",
  orderInfoTitle: "Informazioni sull'autorizzazione dell'account.",
  tableProduct: "Prodotto",
  tableStatus: "Stato",
  tablePermissionDate: "Data di autorizzazione",
  tableValidPeriod: "Periodo valido",
  validStauts: "In vigore",
  expiredStauts: "Scaduto",
  noData: "Nessun dato",
};

export default profile;
